module.exports = __webpack_public_path__ + "static/media/gal-5.bf088f66.jpeg";